import { render } from "./EditContent.vue?vue&type=template&id=3441d62e&scoped=true"
import script from "./EditContent.vue?vue&type=script&lang=js"
export * from "./EditContent.vue?vue&type=script&lang=js"

import "./EditContent.vue?vue&type=style&index=0&id=3441d62e&scoped=true&lang=css"

import exportComponent from "/builds/weborigo-projects/vivien-vance/webshop/core-editor/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3441d62e"]])

export default __exports__